import React from "react";
import cx from "classnames";
import { Icon } from "@foris/avocado-icons";
import { ThemeStore } from "@foris/avocado-suite";
import { useUpdateUserPreferences } from "@common/hooks/useUpdateUserPreferences";
import { ThemeEnum } from "@models/ISchema";
import styles from "./switchTheme.module.scss";

const SwitchTheme: React.FC = () => {
  const themeMode = ThemeStore.useThemeStore(state => state.theme.mode);
  const { updateUserPreferences, isLoading } = useUpdateUserPreferences();

  const toggleTheme = () => {
    if (isLoading) return;

    const newThemeMode = themeMode === ThemeEnum.Dark ? ThemeEnum.Light : ThemeEnum.Dark;
    ThemeStore.setThemeMode(newThemeMode, true);
    updateUserPreferences({ theme: newThemeMode });
  };

  return (
    <div
      className={cx(
        styles.switchTheme,
        themeMode === ThemeEnum.Dark && styles.switchTheme__darkMode,
      )}
    >
      <label className={styles.switchTheme_label}>
        <input
          className={styles.switch}
          type="checkbox"
          onChange={toggleTheme}
          checked={themeMode === ThemeEnum.Dark ? true : false}
          disabled={isLoading}
        />
        <span className={styles.button}>
          <span className={styles.button_iconWrapper}>
            <Icon name={themeMode === ThemeEnum.Dark ? "moon" : "sun"} size="sm" />
          </span>
        </span>
      </label>
    </div>
  );
};

export default SwitchTheme;
